import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import WalterLoader from '../shared/WalterLoader';
import { FaSearch, FaUsers } from 'react-icons/fa';
import { normalizeForSearch } from '../../utils/slugify';
import '../../styles/Admin.css';

const getInitials = (name) => (name || '?')
  .trim()
  .split(/\s+/)
  .slice(0, 2)
  .map((w) => w[0]?.toUpperCase())
  .join('') || '?';

const ClientsList = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/get_clients`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setClients(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchClients();
  }, []);

  const filteredClients = useMemo(() => {
    const query = normalizeForSearch(search);
    if (!query) return clients;
    return clients.filter((client) => normalizeForSearch(client.name_client).includes(query));
  }, [clients, search]);

  if (loading) return (
    <div className="centered-spinner-dashboard">
        <WalterLoader />
    </div>
    );
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="admin-clients-page">
      <div className="admin-clients-header">
        <div className="admin-header-text" style={{ display: 'flex', alignItems: 'center', gap: 16, paddingTop: 0 }}>
          <div className="admin-header-icon"><FaUsers /></div>
          <div>
            <h1>Clients</h1>
            <p>{clients.length} client{clients.length > 1 ? 's' : ''} au total</p>
          </div>
        </div>
        <button className="client-button new-client-button" onClick={() => navigate('/audit')}>
          + Nouveau client
        </button>
      </div>

      {clients.length > 0 && (
        <div className="admin-clients-search">
          <FaSearch />
          <input
            type="text" placeholder="Rechercher un client..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      )}

      {clients.length === 0 ? (
        <div className="admin-card"><div className="admin-empty-state">Aucun client pour l'instant.</div></div>
      ) : filteredClients.length === 0 ? (
        <div className="admin-card"><div className="admin-empty-state">Aucun client ne correspond à « {search} ».</div></div>
      ) : (
        <div className="admin-clients-list">
          {filteredClients.map(client => (
            <div key={client._id} className="admin-client-card">
              <div className="admin-client-avatar">{getInitials(client.name_client)}</div>
              <span className="admin-client-name">{client.name_client}</span>
              <div className="clients-list-two-buttons">
                  <button className="client-button audit-button" onClick={() => navigate(`/audit/${client._id}`)}>Audit</button>
                  <button className="client-button dashboard-button" onClick={() => navigate(`/client/${client._id}`)}>Dashboard</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ClientsList;
